import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import QueryString from 'query-string';
import ReactTable from 'react-table';

import { Message } from '../Message';
import { RowButton } from '../RowButton';
import { EventConfigurationsService } from "../../services";
import { AccessHelper, BaseTable } from '../../helpers';
import i18next from "i18next";

class EventConfigurations extends React.Component {
  constructor(props) {
    super(props);

    const passedState = props.history.location ? props.history.location.state : null;

    this.DEFAULT_SORTED = [{ id: "name", desc: false }];

    this.state = {
      localErrorHandler: this.handleLocalError.bind(this),
      localErrorMessage: null,
      hasError: false,
      data: [],
      pageCount: null,
      forcePage: null,
      loading: true,
      totalElements: null,
      parsedOptions: QueryString.parse(this.props.location.search),
      currentHistoryCount: passedState && passedState.currentHistoryCount ? passedState.currentHistoryCount : 0,
      viewAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/config/events/view/:eventConfigurationId'),
      editAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/config/events/edit/:eventConfigurationId'),
      workflowEnabled: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/config/events/workflows/view/:eventConfigurationId'),
    };
  }

  messageDismissCallback() {
    this.setState({ localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage) {
      return (
          <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    }

    if (this.props.location.state) {
      return (
          <Message messages={this.props.location} />
      );
    }
    return null;
  }

  handleLocalError(localErrorMessage) {
    this.setState({ localErrorMessage: localErrorMessage });
  }

  fetchData(tableData) {
    if (this.updateRequestURL(tableData)) {
      return;
    }

    this.setState({
      loading: true
    });

    let options = BaseTable.buildFetchDataOptions(this.state.parsedOptions, this.DEFAULT_SORTED);

    EventConfigurationsService.getAll(options, false, true).then(response => {
      const pageCount = Math.ceil(response.page.totalElements / this.refs.eventConfigurationsTable.state.pageSize);

      let forcePage = null;
      if (this.refs.eventConfigurationsTable && this.refs.eventConfigurationsTable.state && this.refs.eventConfigurationsTable.state.page >= pageCount) {
        forcePage = pageCount - 1;
      }

      this.setState({
        data: response.eventConfigurations,
        pageCount: pageCount,
        forcePage: forcePage,
        totalElements: response.page.totalElements,
        loading: false
      });
    }).catch(error => {
      console.error(error);
      this.setState({ hasError: true });
      this.state.localErrorHandler(error.message);
    });
  }

  updateRequestURL(tableData) {
    let options = BaseTable.buildURLOptions(tableData, this.DEFAULT_SORTED)

    let params = options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');

    const currentSearch = this.props.location.search ? this.props.location.search : '?';

    if (`?${params}` !== currentSearch) {
      if (this.state.currentHistoryCount > 100) {
        console.error('Exceeded the history count stack of 100.');
        return false;
      }
      this.props.history.push({
        search: `?${params}`,
        state: {
          currentHistoryCount: this.state.currentHistoryCount + 1
        }
      });
      return true;
    } else {
      return false;
    }
  }

  render() {
    let dynamicOptions = BaseTable.buildDynamicOptions(this.state.parsedOptions, this.state.forcePage, this.DEFAULT_SORTED);

    let tableColumns = [];
    tableColumns.push({
      Header: i18next.t('table-headers.name'),
      accessor: "name",
      sortable: true,
      minResizeWidth: 150
    });
    tableColumns.push({
        Header: i18next.t("table-headers.status"),
        accessor: "alertConfigurationStatus.name",
        sortable: false,
        minResizeWidth: 100,
        width: 150,
    });
    if (this.state.workflowEnabled) {
      tableColumns.push({
          Header: i18next.t("table-headers.type"),
          Cell: (cell) => <span>{i18next.t(`event-config-${cell.original.type}`)}</span>,
          sortable: false,
          minResizeWidth: 100,
          width: 150,
      });
    }
    tableColumns.push({
      Cell: cell => <RowButton
                      allowView={this.state.viewAllowed}
                      allowEdit={this.state.editAllowed}
                      viewPath={{
                        pathname: cell.original.type === 'WORKFLOW'
                          ? `/config/events/workflows/view/${cell.original.id}`
                          : `/config/events/view/${cell.original.id}`,
                        state: { backLinkSearch: this.props.location.search }
                      }}
                      editPath={{
                        pathname: cell.original.type === 'WORKFLOW'
                          ? `/config/events/workflows/edit/${cell.original.id}`
                          : `/config/events/edit/${cell.original.id}`,
                        state: { backLinkSearch: this.props.location.search }
                      }}
                    />,
      sortable: false,
      minResizeWidth: 50,
      width: 150
    });

    return (
        <div className="animated fadeIn">
          <div className="row">
            <div className="op-page-header">
              <div className="op-page-header__left">
                <h2 className="op-page-header__title">{i18next.t('pages.event-configurations.header')}</h2>
              </div>
              {
                this.state.workflowEnabled ? 
                <div className="op-page-header__right">
                  <Link to={{ pathname: "/config/events/add", state: { backLinkSearch: this.props.location.search } }}>
                    <div className="btn btn-sm btn-default">{ i18next.t('add-basic') }</div>
                  </Link>
                  &nbsp;&nbsp;&nbsp;
                  <Link to={{ pathname: "/config/events/workflows/add", state: { backLinkSearch: this.props.location.search } }}>
                    <div className="btn btn-sm btn-default">{ i18next.t('add-workflow') }</div>
                  </Link>
                </div> :
                <div className="op-page-header__right">
                  <Link to={{ pathname: "/config/events/add", state: { backLinkSearch: this.props.location.search } }}>
                    <div className="btn btn-sm btn-default">{ i18next.t('add') }</div>
                  </Link>
                </div>
              }
            </div>
          </div>

          {this.renderMessages()}

          <div className="op-content-box">
            <div className="row">
              <div className="col-sm-12">
                <div>
                  <div className="card-block">
                    <div className="react-table-custom">
                      <ReactTable
                        className="-striped -highlight"
                        ref="eventConfigurationsTable"
                        manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                        data={this.state.data}
                        pages={this.state.pageCount} // Display the total number of pages
                        loading={this.state.loading} // Display the loading overlay when we need it
                        totalElements={this.state.totalElements}
                        onFetchData={this.fetchData.bind(this)} // Request new data when things change
                        showPaginationTop
                        columns={tableColumns}
                        {...dynamicOptions}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({ me: state.user.me });

export default connect(mapStateToProps)(EventConfigurations);
